import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component({
    components: {
        imageRow: require('../configurator-image-row').default,
        textRow: require('../configurator-text-row').default,
    }
})
export default class ConfiguratorImageRow extends Vue {

    @Prop() option;
    @Prop() current;
    @Prop() matchedOffers;

    get offers() {
        const items = Array(this.option.options.length);


        this.option.options.forEach((option, i) => {

            items[i] = new Map();

            Object.keys(option.options).forEach((key) => {

                const offer = this.matchedOffers.get(key);

                if (offer) {
                    items[i].set(key, offer);
                }
            });
        })

        return items;
    }

    get showLabel() {
        return !this.option.meta || this.option.meta.showLabel;
    }
}
